import React from 'react';
import './StakeRow.css';
import StakePostCard from './StakePostCard';

export default function StakeRow({ row, onOpenPost }) {
  if (!row || row.type !== 'staked_row') return null;

  const title = row.title || 'Staked Posts';
  const items = Array.isArray(row.items) ? row.items : [];
  if (items.length === 0) return null;

  return (
    <div className="stake-row-wrap">
      <div className="stake-row-header">
        <div className="stake-row-title">{title}</div>
        <div className="stake-row-sub">Sponsored by staking</div>
      </div>

      <div className="stake-row-scroller" role="list">
        {items.map((p, idx) => (
          <div className="stake-row-slide" role="listitem" key={p?._id || idx}>
            <StakePostCard
              post={p}
              onClick={() => p?._id && onOpenPost?.(p._id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
